import { createContext, Dispatch, useEffect, useReducer, useRef } from 'react'

import { WorkspaceReducer } from './workspace.reducer'
import { WorkspaceInitialState } from './workspace.state'
import { WorkspaceState, WorkspaceView } from './workspace.type'

export const WorkspaceStore = createContext(WorkspaceInitialState)
export const currentLocalState = 'workspaceState-v3'
export const DispatchContext = createContext<
  Dispatch<{
    type: string
  }>
>(() => void 0)

export function WorkspaceProvider({
  children,
  value = WorkspaceInitialState,
}: {
  children: React.ReactNode
  value?: typeof WorkspaceInitialState
}): JSX.Element {
  const [state, dispatch] = useReducer(WorkspaceReducer, value)
  const previousLocalState = 'workspaceState-v2'

  // Use ref to access current state in event handler without re-registering listener
  const stateRef = useRef(state)
  stateRef.current = state

  useEffect(() => {
    localStorage.removeItem(previousLocalState)
  }, [])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        localStorage.setItem(currentLocalState, JSON.stringify(stateRef.current))
      }
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return (
    <DispatchContext.Provider value={dispatch}>
      <WorkspaceStore.Provider value={state}>{children}</WorkspaceStore.Provider>
    </DispatchContext.Provider>
  )
}

export const getPreviousWorkspaceState = (state: WorkspaceState) => {
  const { tabs } = state
  const resetTabs = tabs.map((t) => {
    return {
      ...t,
      lastAccessedTime: !t.lastAccessedTime ? new Date() : t.lastAccessedTime,
      potentialBookingId: null,
      potentialBooking: null,
      view: WorkspaceView.SUMMARY,
      potentialBookingFilters: null,
    }
  })
  if (resetTabs.length) {
    let lastAccessedTab = resetTabs[0]
    resetTabs.forEach((t) => {
      if (t.lastAccessedTime > lastAccessedTab.lastAccessedTime) {
        lastAccessedTab = t
      }
    })

    const activeTabId = lastAccessedTab.bookablePersonId
    return { ...state, tabs: resetTabs, activeTabId }
  } else {
    return { ...state, tabs: resetTabs }
  }
}
